import React from 'react';

export const FilesDropdownDots = ({ fill = '#252733', width = 20, height = 20 }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.2383 5.26172C11.2383 5.95207 10.6787 6.51172 9.98834 6.51172C9.29799 6.51172 8.73834 5.95207 8.73834 5.26172C8.73834 4.57136 9.29799 4.01172 9.98834 4.01172C10.6787 4.01172 11.2383 4.57136 11.2383 5.26172Z"
            fill={fill}
        />
        <path
            d="M11.2633 10.0122C11.2633 10.7026 10.7036 11.2622 10.0133 11.2622C9.32293 11.2622 8.76329 10.7026 8.76329 10.0122C8.76329 9.32185 9.32293 8.76221 10.0133 8.76221C10.7036 8.76221 11.2633 9.32185 11.2633 10.0122Z"
            fill={fill}
        />
        <path
            d="M11.2368 14.7617C11.2368 15.4521 10.6772 16.0117 9.98682 16.0117C9.29646 16.0117 8.73682 15.4521 8.73682 14.7617C8.73682 14.0714 9.29646 13.5117 9.98682 13.5117C10.6772 13.5117 11.2368 14.0714 11.2368 14.7617Z"
            fill={fill}
        />
    </svg>
);
